export default "__VITE_ASSET__DUOFHRWM__"